import React, { useState, useEffect } from 'react';
import {
  Button,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Select,
  Alert,
  Snackbar,
  InputLabel,
  FormControl,
  styled,
  OutlinedInput,
  Accordion,
  AccordionActions,
  AccordionSummary,
  AccordionDetails,
  Backdrop,
  CircularProgress,
  Dialog,
  IconButton,
  Box,
  Stack
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router';
import { CspCodeActivateApi, CspCodeActivateApiPut, CspCodeCreateApi, OdBankList } from 'API/Services';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import CancelIcon from '@mui/icons-material/Cancel';
import { BankAccNumberVerify } from 'API/BankAccountVerify';
import { GetFieldData } from 'API/Approval/api';
import CloseIcon from '@mui/icons-material/Close';
// import MainCard from 'ui-component/cards/MainCard';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SendIcon from '../../../../assets/images/icons/send_link.png';
import {
  checkPaymentStatusAtCodeCreation,
  PostResendLinkAtCodeCreation,
  postSecondPaymentLinkAtCodeCreation
} from 'API/AgentOnboarding/api';
import ResendDialog from 'views/utilities/Components/PaymentStatus/ResendDialog';

const Details = () => {
  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
  });
  const Navigate = useNavigate();
  const location = useLocation();
  const [StateData, setStateData] = useState(location.state);
  console.log('StateData', StateData);

  const BankAccVerified = sessionStorage.getItem('BankAccVerified');

  const extractDateOnly = (dateTimeString) => {
    if (dateTimeString) {
      return dateTimeString.split(' ')[0];
    }
    return '';
  };

  const [open, setOpen] = React.useState(false);
  const dateTimeString = StateData && StateData.codecreatedate;
  const dateOnly = extractDateOnly(dateTimeString);
  const create = new Date(dateTimeString);
  const [Data, setData] = useState({});
  const [Upload, setUpload] = useState('');
  const [UploadError, setUploadError] = useState(false);
  const [Success, setSuccess] = useState(false);
  const [ErrorRes, setErrorRes] = useState(false);
  const [Error, setError] = useState({
    agent_code: false,
    agent_name: false,
    bank_name: false,
    csp_code: false,
    csp_type: false,
    csp_status: false,
    csp_code_creation_date: false
  });
  const [ErrOpen, setErrOpen] = useState(false);
  const [AlerType, setAlertType] = useState('success');
  // console.log("AlerType", AlerType);
  const [AlertMessage, setAlertMessage] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [Verified, setVerified] = useState(false);
  const [VerifyResponse, setVerifyResponse] = useState(null);
  const [HandleVerify, setHandleVerify] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [IsLoadingEdit, setIsLoadingEdit] = useState(false);
  const [IsLoadingAct, setIsLoadingAct] = useState(false);
  const [ErrMessage, setErrMessage] = useState('');
  const [Size, setSize] = useState(false);
  const [Type, setType] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [openResend, setOpenResend] = useState(false);
  const [ResendId, setResendId] = useState(null);

  const handleChange = (name, event) => {
    setData({ ...Data, [name]: event });
    setError({ ...Error, [name]: false });
  };

  const handleAlertOpen = (message, type) => {
    setAlertType(type);
    setAlertMessage(message);
    setErrOpen(true);
  };

  const handleImageUpload = (file) => {
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];

    if (file.size > maxSize) {
      setSize(true);
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      setType(true);
      return;
    }
    setUpload(file);
    setFileType(file.type);
    setFileUrl(URL.createObjectURL(file));
  };
  // const handleImageClose = () => {
  //   setUpload(false);
  // };

  const handleSubmit = () => {
    if (!Data.csp_code && UserData && !UserData[0].csp_code) {
      setError({ ...Error, csp_code: true });
      setErrMessage('Csp code is required');
    } else if (!Data.csp_code_creation_date) {
      setError({ ...Error, csp_code_creation_date: true });
      setErrMessage('Csp code creation date is required');
    } else {
      if (StateData.type === 'create') {
        // if(!Data.csp_code&&(UserData&&!UserData[0].csp_code)){
        //   alert('please enter CSP Code')
        // }
        CspCodeCreateApi(Data, StateData, UserData, handleClick, setSuccess, handleError, setErrorRes, setIsLoading);
      } else {
        CspCodeActivateApiPut(Data, StateData, handleClick, setSuccess, handleError, setErrorRes, setIsLoadingEdit);
      }
    }
  };
  const handleClick = () => {
    setSuccess(true);
    setTimeout(() => {
      sessionStorage.removeItem('BankAccVerified');
      Navigate(-1);
    }, 2000);
  };
  const handleError = () => {
    setErrorRes(true);
  };
  const handleUploadClose = () => {
    setUploadError(false);
    setSuccess(false);
    setErrorRes(false);
  };

  const [ActivateData, setActivateData] = useState({});
  const [ActivateErrMessage, setActivateErrMessage] = useState('');
  const [ActivateError, setActivateError] = useState({
    activation_remarks: false,
    vtc_code: false,
    od_bank_name: false,
    od_account_number: false,
    od_account_name: false,
    od_ifsc_code: false,
    csp_code_activation_date: false,
    first_transaction_document: false
  });
  const [Datevali, setDatevali] = useState(false);
  const [NameBank, setNameBank] = useState('');
  const [BankList, setBankList] = useState('');
  const [VerifyButton, setVerifyButton] = useState(false);

  const ifscregex = /^[A-Z]{4}\d{7}$/;
  const accnoregex = /^[0-9]{8,20}$/;
  const numonly = /^[0-9]+$/;
  const activate = new Date(ActivateData.csp_code_activation_date);

  const handleActivateChange = (name, event) => {
    setActivateData({ ...ActivateData, [name]: event });
    setActivateError({ ...ActivateError, [name]: false });
  };
  const handleActivateSubmit = () => {
    if (!ActivateData.csp_code_activation_date) {
      setActivateError({ ...ActivateError, csp_code_activation_date: true });
      setActivateErrMessage('Csp Code Activation Date is required');
    } else if (Data && Data.csp_code && Data.csp_code === '') {
      setActivateError({ ...ActivateError, csp_code_activation_date: true });
      setActivateErrMessage('Csp Code is required');
    } else if (!Upload) {
      setUploadError(true);
    } else if (activate < create) {
      setActivateError({ ...ActivateError, csp_code_activation_date: true });
      setActivateErrMessage('CSP activation date is greater than creation date');
    } else {
      CspCodeActivateApi(ActivateData, Upload, StateData, handleClick, NameBank, setSuccess, handleError, setErrorRes, setIsLoadingAct);
    }
  };
  const handleBankSubmit = () => {
    if (!ActivateData.od_bank_name && !BankList.Full_Bank_Name) {
      setActivateError({ ...ActivateError, od_bank_name: true });
      setActivateErrMessage('OD bank name is required');
    } else if (!ActivateData.od_ifsc_code) {
      setActivateError({ ...ActivateError, od_ifsc_code: true });
      setActivateErrMessage('OD ifsc number is required');
    } else if (!ActivateData.od_account_number) {
      setActivateError({ ...ActivateError, od_account_number: true });
      setActivateErrMessage('OD account number is required');
    } else if (ActivateData.od_account_number && !accnoregex.test(ActivateData.od_account_number)) {
      setActivateError({ ...ActivateError, od_account_number: true });
      setActivateErrMessage('Invalid Account number');
    } else if (ActivateData.od_account_number && !numonly.test(ActivateData.od_account_number)) {
      setActivateError({ ...ActivateError, od_account_number: true });
      setActivateErrMessage('Invalid Account number');
    } else if (ActivateData.od_ifsc_code && !ifscregex.test(ActivateData.od_ifsc_code)) {
      setActivateError({ ...ActivateError, od_ifsc_code: true });
      setActivateErrMessage('Invalid ifsc format');
    } else {
      if (BankAccVerified) {
        CspCodeActivateApi(ActivateData, Upload, StateData, handleClick, NameBank, setSuccess, handleError, setErrorRes, setIsLoadingAct);
      } else {
        setHandleVerify(true);
      }
    }
  };
  console.log('dfghj', dateOnly);

  const handleErrClose = () => {
    setErrOpen(false);
    setHandleVerify(false);
    setDatevali(false);
    setType(false);
    setSize(false);
    setVerifyButton(false);
    // setCheckStatus(false)
  };

  const handleBankNoVerify = (ifsc_code, account_number, name) => {
    if (!Verified && !VerifyResponse) {
      BankAccNumberVerify(
        ifsc_code,
        account_number,
        setAlertMessage,
        setErrOpen,
        setVerified,
        setAlertType,
        setOpenLoader,
        setVerifyResponse,
        setNameBank,
        name
        // setFieldChange
      );
    }
  };

  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z0-9]/g, '');
  };
  const handleBanknameInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z\s]/g, '');
  };
  const handleRemarkInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z0-9\s]/g, '');
  };
  const handleIfscInput = (e) => {
    const value = e.target.value;
    // e.target.value = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    if (value.length <= 11) {
      e.target.value = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    } else {
      e.target.value = value.slice(0, 11); // Limit to 11 characters
    }
  };
  const handleAccnoInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^0-9]/g, '');
  };
  const [UserData, setUserData] = useState('');

  const dummy = ['csp_code', 'csp_type'];
  useEffect(() => {
    GetFieldData(setUserData, dummy, StateData.userId);
    OdBankList(StateData.productid, setBankList);
  }, []);
  console.log('BankList', BankList);

  const handleResendPayment = (item) => {
    console.log('part link', item);
    // checkPaymentStatus(params,setStatusLoading,setAlertMessage,setAlertType,setAlertOpen,getAllPayments,setData,setIsLoading)
    postSecondPaymentLinkAtCodeCreation(item, setAlertMessage, setAlertType, setErrOpen, setIsLoading, setStateData, handleAlertOpen);
  };

  const handleCheckStatus = (params) => {
    console.log('params', params);
    // setButtonIndex(index);
    checkPaymentStatusAtCodeCreation(params, setIsLoading, handleAlertOpen, setStateData);
  };

  const handleOpenResendDialog = (id) => {
    setResendId(id);
    setOpenResend(true);
  };

  const handleCloseResendDialog = () => {
    setOpenResend(false);
  };

  const handlePostResendLink = () => {
    PostResendLinkAtCodeCreation(ResendId, setIsLoading, handleAlertOpen, handleCloseResendDialog, setStateData);
  };

  return (
    <>
      <ResendDialog open={openResend} handleClose={handleCloseResendDialog} isLoading={IsLoading} handleSubmit={handlePostResendLink} />

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
        <IconButton
          aria-label="close"
          onClick={() => setOpen(false)}
          sx={{
            position: 'absolute',
            right: 0,
            top: 2,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <div style={{ padding: '20px', paddingTop: '35px' }}>
          {/* Preview for PDF */}
          {fileUrl && fileType === 'application/pdf' && (
            <>
              <Typography variant="h5" mb={2}>
                Pdf
              </Typography>
              <iframe src={fileUrl} title="PDF Preview" width="100%" height="600px" style={{ border: 'none' }} />
            </>
          )}

          {/* Preview for Images (JPG, PNG) */}
          {fileUrl && (fileType === 'image/jpeg' || fileType === 'image/png') && (
            <>
              <Typography variant="h5" mb={2}>
                Image
              </Typography>
              <img src={fileUrl} alt="Uploaded file preview" style={{ maxWidth: '100%', height: 'auto' }} />
            </>
          )}
        </div>
      </Dialog>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={IsLoading || IsLoadingEdit || IsLoadingAct}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={ErrOpen} autoHideDuration={5000} onClose={handleErrClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleErrClose} variant="filled" severity={AlerType} sx={{ width: '100%' }}>
          {AlertMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={HandleVerify}
        autoHideDuration={5000}
        onClose={handleErrClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleErrClose} variant="filled" severity="warning" sx={{ width: '100%' }}>
          please verify your Account number
        </Alert>
      </Snackbar>
      <Snackbar open={Type} autoHideDuration={5000} onClose={handleErrClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleErrClose} variant="filled" severity="error" sx={{ width: '100%' }}>
          Only PDF, JPG, JPEG, and PNG files are allowed.
        </Alert>
      </Snackbar>
      <Snackbar open={Size} autoHideDuration={5000} onClose={handleErrClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleErrClose} variant="filled" severity="error" sx={{ width: '100%' }}>
          File size should not exceed 5MB.
        </Alert>
      </Snackbar>
      <Snackbar
        open={VerifyButton}
        autoHideDuration={5000}
        onClose={handleErrClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleErrClose} variant="filled" severity="error" sx={{ width: '100%' }}>
          Please enter valid Account number and IFSC
        </Alert>
      </Snackbar>
      <Snackbar
        open={UploadError}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={handleUploadClose}
      >
        <Alert severity="error" variant="filled" sx={{ width: '100%' }} onClose={handleUploadClose}>
          Please upload a file
        </Alert>
      </Snackbar>
      <Snackbar open={Success} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={6000} onClose={handleUploadClose}>
        <Alert severity="success" variant="filled" sx={{ width: '100%' }} onClose={handleUploadClose}>
          {Success}
        </Alert>
      </Snackbar>
      <Snackbar open={ErrorRes} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={6000} onClose={handleUploadClose}>
        <Alert severity="error" variant="filled" sx={{ width: '100%' }} onClose={handleUploadClose}>
          {ErrorRes}
        </Alert>
      </Snackbar>
      <Snackbar open={Datevali} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={6000} onClose={handleErrClose}>
        <Alert severity="error" variant="filled" sx={{ width: '100%' }} onClose={handleErrClose}>
          CSP activation date is greater than creation date
        </Alert>
      </Snackbar>

      {StateData && StateData.type === 'create' ? (
        <>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ fontWeight: '700', fontSize: '18px' }}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              Code Creation Detail
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2} xl={12}>
                <Grid item xl={4} lg={4} md={4} xs={6}>
                  <TextField
                    id="outlined-basic"
                    // error={Error.agent_code}
                    fullWidth
                    value={Data.agent_code ? Data.agent_code : StateData ? StateData.code : ''}
                    label="Agent Code"
                    variant="outlined"
                    name="agent_code"
                    onChange={(e) => handleChange('agent_code', e.target.value)}
                    inputProps={{
                      readOnly: true
                    }}
                    sx={{
                      input: {
                        background: '#f0f0f0'
                      }
                    }}
                  />
                  {/* <Typography display={Error.agent_code ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                {ErrMessage}
              </Typography> */}
                </Grid>
                <Grid item xl={4} lg={4} md={4} xs={6}>
                  <TextField
                    id="outlined-basic"
                    // error={Error.agent_name}
                    fullWidth
                    value={Data.agent_name ? Data.agent_name : StateData ? StateData.name : ''}
                    // disabled={DisableNumber ? DisableNumber : false}
                    label="Agent Name"
                    variant="outlined"
                    name="agent_name"
                    onChange={(e) => handleChange('agent_name', e.target.value)}
                    inputProps={{
                      readOnly: true
                    }}
                    sx={{
                      input: {
                        background: '#f0f0f0'
                      }
                    }}
                  />
                  {/* <Typography display={Error.agent_name ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                {ErrMessage}
              </Typography> */}
                </Grid>
                <Grid item xl={4} lg={4} md={4} xs={6}>
                  <TextField
                    id="outlined-basic"
                    // error={Error.bank_name}
                    fullWidth
                    value={Data.bank_name ? Data.bank_name : StateData ? StateData.bank : ''}
                    label="Bank Name"
                    // disabled={DisableEmail ? DisableEmail : false}
                    type="text"
                    variant="outlined"
                    name="bank_name"
                    onChange={(e) => handleChange('bank_name', e.target.value)}
                    inputProps={{
                      readOnly: StateData && StateData.bank
                    }}
                    sx={{
                      input: {
                        background: '#f0f0f0'
                      }
                    }}
                  />
                  {/* <Typography display={Error.bank_name ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                {ErrMessage}
              </Typography> */}
                </Grid>
              </Grid>
              <Grid container spacing={2} xl={12} sx={{ mt: 1 }}>
                <Grid item xl={4} lg={6} md={6} sm={6} xs={6}>
                  <TextField
                    id="outlined-basic"
                    error={Error.csp_code}
                    fullWidth
                    label="CSP Code"
                    value={Data.csp_code || Data.csp_code === '' ? Data.csp_code : UserData && UserData[0].csp_code}
                    // disabled={DisableEmail ? DisableEmail : false}
                    type="text"
                    variant="outlined"
                    onInput={handleIfscInput}
                    name="csp_code"
                    onChange={(e) => handleChange('csp_code', e.target.value)}
                    // onInput={handleInput}
                    // inputProps={{
                    //   readOnly: UserData && UserData[0].csp_code
                    // }}
                    inputProps={{
                      readOnly: !(sessionStorage.getItem('UserType') === 'ops') && UserData && UserData[0]?.csp_code
                    }}
                    sx={{
                      input: {
                        background: UserData && UserData[0].csp_code ? '#f0f0f0' : '#FFFFF2'
                      }
                    }}
                  />
                  <Typography display={Error.csp_code ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                    {ErrMessage}
                  </Typography>
                </Grid>

                <Grid item xl={4} lg={6} md={6} sm={6} xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">CSP Type</InputLabel>
                    <Select
                      labelid="demo-simple-select-label"
                      id="demo-simple-select"
                      // error={Error.csp_type}
                      value={Data.csp_type ? Data.csp_type : UserData ? UserData[0].csp_type : 'select'}
                      name="csp_type"
                      label="CSP Type"
                      onChange={(e) => handleChange('csp_type', e.target.value)}
                      // inputProps={{
                      //   readOnly: UserData && UserData[0].csp_type
                      // }}
                      inputProps={{
                        readOnly: !(sessionStorage.getItem('UserType') === 'ops') && UserData && UserData[0]?.csp_type
                      }}
                      sx={{
                        '.MuiSelect-select': {
                          backgroundColor: UserData && UserData[0].csp_type ? '#f0f0f0' : '#FFFFF2'
                        }
                      }}
                    >
                      <MenuItem sx={{ display: 'none' }} value={UserData && UserData[0].csp_type}>
                        {UserData && UserData[0].csp_type}
                      </MenuItem>
                      <MenuItem value={'select'} disabled>
                        select
                      </MenuItem>
                      <MenuItem value={'New'}>New</MenuItem>
                      <MenuItem value={'Migrated'}>Migrated</MenuItem>
                      <MenuItem value={'Replacement'}>Replacement</MenuItem>
                    </Select>
                  </FormControl>
                  {/* <Typography display={Error.csp_type ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                {ErrMessage}
              </Typography> */}
                </Grid>
                <Grid item xl={4} lg={6} md={4} xs={6} sx={{ display: 'none' }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">CSP Status</InputLabel>
                    <Select
                      labelid="demo-simple-select-label"
                      id="demo-simple-select"
                      // error={Error.csp_status}
                      value={Data.csp_status ? Data.csp_status : StateData ? StateData.cspstatus : 'select'}
                      name="csp_status"
                      label="CSP Status"
                      onChange={(e) => handleChange('csp_status', e.target.value)}
                    >
                      <MenuItem value={'select'} disabled>
                        select
                      </MenuItem>
                      <MenuItem value={'Active'}>Active</MenuItem>
                      <MenuItem value={'Code created'}>Code Created</MenuItem>
                      <MenuItem value={'Inactive'}>Inactive</MenuItem>
                      <MenuItem value={'Pending'}>Pending</MenuItem>
                    </Select>
                  </FormControl>
                  {/* <Typography display={Error.csp_status ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                {ErrMessage}
              </Typography> */}
                </Grid>
              </Grid>
              <Grid container spacing={2} xl={12} sx={{ mt: 1 }} alignItems="flex-end" justifyContent="space-between">
                <Grid item xl={4} lg={6} md={6} xs={6}>
                  <InputLabel sx={{ mb: '10px' }}>Csp Code Creation Date</InputLabel>
                  <TextField
                    id="outlined-basic"
                    required
                    error={Error.csp_code_creation_date}
                    fullWidth
                    value={Data.csp_code_creation_date ? Data.csp_code_creation_date : StateData ? StateData.codecreatedate : ''}
                    //   label="Code Creation Date"
                    // disabled={DisableEmail ? DisableEmail : false}
                    type="date"
                    variant="outlined"
                    name="csp_code_creation_date"
                    onChange={(e) => handleChange('csp_code_creation_date', e.target.value)}
                    InputProps={{
                      inputProps: {
                        max: new Date().toISOString().split('T')[0] // Setting max to today
                      }
                    }}
                    sx={{
                      input: {
                        background: '#FFFFF2'
                      }
                    }}
                  />
                  <Typography display={Error.csp_code_creation_date ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                    {ErrMessage}
                  </Typography>
                </Grid>
                <Grid sx={{ visibility: 'hidden' }} item xl={2} lg={2} md={2} xs={6}>
                  <Button variant="contained" fullWidth component="label" size="large" color="primary">
                    Send Payment Link
                  </Button>
                </Grid>

                <Grid sx={{ visibility: 'hidden' }} item xl={3} lg={3} md={3} xs={6}>
                  <Button variant="contained" fullWidth component="label" size="large" color="warning">
                    Check Payment Status
                  </Button>
                </Grid>
              </Grid>
            </AccordionDetails>
            <AccordionActions sx={{ display: 'flex', justifyContent: 'center' }}>
              <Grid item xl={4} lg={4} md={4} xs={12} display="flex" justifyContent="center" mt={2}>
                <Button
                  variant="outlined"
                  size="large"
                  color="secondary"
                  // sx={{ width: '120%', marginRight: '15px' }}
                  sx={{
                    width: '120%',
                    marginRight: '15px',
                    borderColor: '#688B2A',
                    color: '#688B2A',
                    borderRadius: '6px',
                    '&:hover': {
                      borderColor: '#688B2A'
                    }
                  }}
                  onClick={() => Navigate('/Admin/Csp_Code_Activation', { state: { setValue: 0 } })}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  color="secondary"
                  sx={{
                    width: '120%',
                    backgroundColor: '#688B2A',
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#688B2A'
                    }
                  }}
                  onClick={handleSubmit}
                >
                  submit
                </Button>
              </Grid>
            </AccordionActions>
          </Accordion>
          {/* <MainCard sx={{ mt: 1 }} title="Payment Details"> */}
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ fontWeight: '700', fontSize: '18px' }}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              Payment Details
            </AccordionSummary>
            {StateData?.payment_data?._id ? (
              <Grid xs={12}>
                {StateData.payment_data ? (
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Agent Name</TableCell>
                          <TableCell>Mobile Number</TableCell>
                          <TableCell>Type of payment</TableCell>
                          <TableCell>Total Amount</TableCell>
                          <TableCell>Part Amount</TableCell>
                          <TableCell>Due Amount</TableCell>
                          <TableCell>Due Date</TableCell>
                          <TableCell>Installment 1 Status</TableCell>
                          <TableCell>Installment 2 Status</TableCell>
                          <TableCell>Next Installment</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {/* {rows.map((row) => ( */}
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell align="right">
                            {StateData?.payment_data && StateData?.payment_data?.customer_details?.customer_name}
                          </TableCell>
                          <TableCell align="right">
                            {StateData?.payment_data && StateData?.payment_data?.customer_details?.customer_mobile}
                          </TableCell>
                          <TableCell align="right">
                            {StateData?.payment_data &&
                            StateData?.payment_data?.payment_details &&
                            StateData?.payment_data?.payment_details?.installment_1?.payment_type === 'full_payment'
                              ? 'Full Payment'
                              : 'Part Payment'}
                          </TableCell>
                          <TableCell align="right">
                            {StateData?.payment_data &&
                              StateData?.payment_data?.payment_details &&
                              StateData?.payment_data?.payment_details?.installment_1?.total_amount}
                          </TableCell>
                          <TableCell>
                            {StateData?.payment_data &&
                            StateData?.payment_data?.payment_details?.installment_1 &&
                            StateData?.payment_data?.payment_details?.installment_1?.part_amount
                              ? parseFloat(
                                  StateData?.payment_data?.payment_details?.installment_1 &&
                                    StateData?.payment_data?.payment_details?.installment_1.part_amount
                                    ? StateData?.payment_data?.payment_details?.installment_1?.part_amount
                                    : '-'
                                )
                              : '-'}
                          </TableCell>

                          <TableCell>
                            {StateData?.payment_data && StateData?.payment_data?.payment_details?.installment_1?.balance_amount
                              ? StateData.payment_data?.payment_details?.installment_1?.balance_amount
                              : '-'}
                          </TableCell>

                          <TableCell>
                            {StateData?.payment_data && StateData?.payment_data?.payment_details?.installment_1?.due_date
                              ? StateData?.payment_data?.payment_details?.installment_1?.due_date
                              : '-'}
                          </TableCell>

                          <TableCell>
                            <Stack direction="row" gap={1} alignItems="center">
                              {StateData?.payment_data &&
                              StateData?.payment_data?.payment_details?.installment_1?.payment_status === 'successful' ? (
                                <Button variant="contained" color="success">
                                  Success
                                </Button>
                              ) : StateData.payment_data?.payment_details?.installment_1?.payment_status === 'aborted' ? (
                                <Button variant="contained" color="error" onClick={() => handleCheckStatus(StateData?.payment_data)}>
                                  Aborted
                                </Button>
                              ) : (
                                <Button variant="text" onClick={() => handleCheckStatus(StateData?.payment_data)}>
                                  Check
                                </Button>
                              )}

                              {StateData?.payment_data?.payment_details?.installment_1?.payment_status !== 'successful' ? (
                                <Button
                                  variant="contained"
                                  color="warning"
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: 0, // Prevents default button width
                                    padding: '4px', // Adjust padding to make it smaller
                                    width: '32px', // Define an explicit size
                                    height: '32px', // Ensures a square shape
                                    borderRadius: '10%' // Makes it circular (optional)
                                  }}
                                  onClick={() => handleOpenResendDialog(StateData?.payment_data._id)}
                                >
                                  <img style={{ width: '90%', height: '90%' }} src={SendIcon} alt="icon" />
                                </Button>
                              ) : null}
                            </Stack>
                          </TableCell>

                          <TableCell align="right">
                            <Stack direction="row">
                              {StateData?.payment_data?.payment_details?.installment_2 ? (
                                StateData?.payment_data?.payment_details?.installment_2?.payment_status === 'successful' ? (
                                  <Button variant="contained" color="success">
                                    Success
                                  </Button>
                                ) : StateData?.payment_data?.payment_details?.installment_2?.payment_status === 'aborted' ? (
                                  <Button variant="contained" color="error" onClick={() => handleCheckStatus(StateData?.payment_data)}>
                                    Aborted
                                  </Button>
                                ) : (
                                  <Button variant="text" onClick={() => handleCheckStatus(StateData?.payment_data)}>
                                    Check
                                  </Button>
                                )
                              ) : (
                                '-'
                              )}
                              {StateData?.payment_data?.payment_details?.installment_2 &&
                              StateData?.payment_data?.payment_details?.installment_2?.payment_status !== 'successful' ? (
                                <Button
                                  variant="contained"
                                  color="warning"
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: 0, // Prevents default button width
                                    padding: '4px', // Adjust padding to make it smaller
                                    width: '32px', // Define an explicit size
                                    height: '32px', // Ensures a square shape
                                    borderRadius: '10%' // Makes it circular (optional)
                                  }}
                                  onClick={() => handleOpenResendDialog(StateData?.payment_data._id)}
                                >
                                  <img style={{ width: '90%', height: '90%' }} src={SendIcon} alt="icon" />
                                </Button>
                              ) : null}
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="text"
                              disabled={
                                StateData?.payment_data?.payment_details?.installment_1?.payment_type == 'full_payment'
                                  ? true
                                  : StateData?.payment_data?.payment_details?.installment_2 ||
                                    StateData?.payment_data?.payment_details?.installment_1?.payment_status !== 'successful'
                                  ? true
                                  : false
                              }
                              onClick={() => handleResendPayment(StateData?.payment_data)}
                            >
                              {StateData?.payment_data?.payment_details?.installment_2 ? 'Link Generated' : 'Request'}
                            </Button>
                          </TableCell>
                        </TableRow>
                        {/* ))} */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Stack justifyContent="center" alignItems="center">
                    <Typography>No Data Found</Typography>
                  </Stack>
                )}
              </Grid>
            ) : (
              <Stack justifyContent="center" alignItems="center" m={2}>
                <Typography variant="h4">No payment data Found</Typography>
              </Stack>
            )}
          </Accordion>
          {/* </MainCard> */}
        </>
      ) : (
        <>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ fontWeight: '700', fontSize: '18px' }}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              Code Activation Detail
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2} xl={12}>
                <Grid item xl={4} lg={4} md={4} sm={6} xs={12} sx={{ display: 'none' }}>
                  <TextField
                    id="outlined-basic"
                    error={ActivateError.vtc_code}
                    fullWidth
                    value={ActivateData.vtc_code ? ActivateData.vtc_code : ''}
                    label="VTC Code*"
                    // disabled={DisableEmail ? DisableEmail : false}
                    type="text"
                    variant="outlined"
                    onInput={handleInput}
                    name="vtc_code"
                    onChange={(e) => handleActivateChange('vtc_code', e.target.value)}
                    sx={{
                      input: {
                        background: '#f9f9f9'
                      }
                    }}
                  />
                  <Typography display={ActivateError.vtc_code ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                    {ActivateErrMessage}
                  </Typography>
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
                  <InputLabel id="demo-simple-select-label" sx={{ mb: '10px' }}>
                    Activation Remarks
                    {/* <span style={{ color: 'red' }}>*</span> */}
                  </InputLabel>
                  <FormControl fullWidth>
                    <TextField
                      id="outlined-basic"
                      error={ActivateError.activation_remarks}
                      fullWidth
                      value={ActivateData.activation_remarks ? ActivateData.activation_remarks : ''}
                      // label="Activation Remarks"
                      // disabled={DisableEmail ? DisableEmail : false}
                      type="text"
                      variant="outlined"
                      name="activation_remarks"
                      onChange={(e) => handleActivateChange('activation_remarks', e.target.value)}
                      onInput={handleRemarkInput}
                      sx={{
                        input: {
                          background: '#f9f9f9'
                        }
                      }}
                    />
                  </FormControl>
                  <Typography display={ActivateError.activation_remarks ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                    {ActivateErrMessage}
                  </Typography>
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
                  <InputLabel sx={{ mb: '10px' }}>
                    CSP Code<span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <TextField
                    id="outlined-basic"
                    // error={ActivateError.csp_code}
                    fullWidth
                    // label="CSP Code"
                    value={ActivateData.csp_code ? ActivateData.csp_code : StateData ? StateData.cspcode : ''}
                    // disabled={DisableEmail ? DisableEmail : false}
                    type="text"
                    variant="outlined"
                    name="csp_code"
                    sx={{
                      input: {
                        background: '#f0f0f0'
                      }
                    }}
                    onChange={(e) => handleActivateChange('csp_code', e.target.value)}
                    inputProps={{
                      readOnly: StateData && StateData.cspcode
                    }}
                  />
                  {/* <Typography display={ActivateError.csp_code ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                {ActivateErrMessage}
              </Typography> */}
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
                  <InputLabel sx={{ mb: '10px' }}>
                    Csp Code Activation Date<span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <TextField
                    id="outlined-basic"
                    error={ActivateError.csp_code_activation_date}
                    fullWidth
                    value={ActivateData.csp_code_activation_date ? ActivateData.csp_code_activation_date : ''}
                    //   label="Code Creation Date"
                    // disabled={DisableEmail ? DisableEmail : false}
                    type="date"
                    variant="outlined"
                    name="csp_code_activation_date"
                    onChange={(e) => handleActivateChange('csp_code_activation_date', e.target.value)}
                    InputProps={{
                      inputProps: {
                        min: StateData.codecreatedate,
                        onKeyDown: (e) => e.preventDefault(),
                        max: new Date().toISOString().split('T')[0] // Setting max to today
                      }
                    }}
                  />
                  <Typography display={ActivateError.csp_code_activation_date ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                    {ActivateErrMessage}
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ mt: 3 }}>
                <Grid item xl={4} lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex' }}>
                  <InputLabel sx={{ mb: '0px', lineHeight: '2.4375em' }}>
                    First transaction Document<span style={{ color: 'red' }}>*</span>:
                  </InputLabel>
                  {Upload ? (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Button component="label" variant="contained" sx={{ ml: 2, mt: '0px' }} color="secondary">
                        upload
                        <VisuallyHiddenInput
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png"
                          name="first_transaction_document"
                          onChange={(e) => {
                            handleImageUpload(e.target.files[0]);
                          }}
                        />
                      </Button>
                      <Button color="secondary" fullWidth sx={{ ml: '5px', mt: '0px' }} onClick={() => setOpen(true)}>
                        View doc
                      </Button>
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Button
                        component="label"
                        variant="contained"
                        //         sx={{
                        //           ml: 2,
                        // width: '100%',
                        //   backgroundColor: '#592375',
                        //   color: '#FFFFFF',
                        //   borderRadius: '6px',
                        //   '&:hover': {
                        //     backgroundColor: '#592375'
                        //   }
                        // }}
                        sx={{ ml: 2 }}
                        color="secondary"
                      >
                        upload
                        <VisuallyHiddenInput
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png"
                          name="first_transaction_document"
                          onChange={(e) => {
                            handleImageUpload(e.target.files[0]);
                          }}
                        />
                      </Button>
                    </Box>
                  )}
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={2} xs={2} sx={{ mt: '2.2rem' }}></Grid>
              </Grid>
            </AccordionDetails>
            <AccordionActions sx={{ display: 'flex', justifyContent: 'center' }}>
              <Grid item xl={3} lg={3} md={3} xs={12} display="flex" justifyContent="center" mt={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="large"
                  // sx={{ width: '100%', marginRight: '15px' }}
                  sx={{
                    width: '100%',
                    marginRight: '15px',
                    borderColor: '#688B2A',
                    color: '#688B2A',
                    borderRadius: '6px',
                    '&:hover': {
                      borderColor: '#688B2A'
                    }
                  }}
                  // onClick={() => {
                  //   sessionStorage.removeItem('BankAccVerified'),
                  //     Navigate(-1, {
                  //       state: { setValue: 1 }
                  //     });
                  // }}
                  onClick={() => {
                    sessionStorage.removeItem('BankAccVerified'); // Use semicolon to terminate this statement
                    Navigate('/Admin/Csp_Code_Activation', { state: { setValue: 1 } }); // Ensure `Navigate` is called after the first statement
                  }}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  sx={{
                    width: '100%',
                    backgroundColor: '#688B2A',
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#688B2A'
                    }
                  }}
                  //  sx={{ width: '100%' }}
                  onClick={handleActivateSubmit}
                >
                  submit
                </Button>
              </Grid>
            </AccordionActions>
          </Accordion>
          {sessionStorage.getItem('UserType') === 'ft' ? null : (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ fontWeight: '700', fontSize: '18px' }}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                OD Bank Details
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2} xl={12} sx={{ mt: 1 }}>
                  <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                    {/* <InputLabel htmlFor="outlined-adornment-lname-register" sx={{ mb: '10px' }}>
                  OD Bank Account Name
                    </InputLabel> */}
                    <InputLabel htmlFor="outlined-adornment-lname-register" sx={{ mb: '10px' }}>
                      OD Bank Account Name
                    </InputLabel>
                    <TextField
                      id="outlined-basic"
                      error={ActivateError.od_bank_name}
                      fullWidth
                      value={ActivateData.od_bank_name ? ActivateData.od_bank_name : BankList.Full_Bank_Name}
                      // label="OD Account Bank Name"
                      // disabled={DisableEmail ? DisableEmail : false}
                      type="text"
                      variant="outlined"
                      name="od_bank_name"
                      onChange={(e) => handleActivateChange('od_bank_name', e.target.value)}
                      onInput={handleBanknameInput}
                      inputProps={{
                        readOnly: true
                      }}
                    />
                    <Typography display={ActivateError.od_bank_name ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                      {ActivateErrMessage}
                    </Typography>
                  </Grid>

                  <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                    <InputLabel htmlFor="outlined-adornment-lname-register" sx={{ mb: '10px' }}>
                      OD Bank Account IFSC Code
                    </InputLabel>
                    <TextField
                      id="outlined-basic"
                      error={ActivateError.od_ifsc_code}
                      fullWidth
                      value={
                        ActivateData.od_ifsc_code
                          ? ActivateData.od_ifsc_code
                          : BankList.first_four_ifsc
                          ? BankList.first_four_ifsc
                          : sessionStorage.getItem('od_ifsc_code')
                      }
                      inputProps={{
                        readOnly: BankAccVerified
                      }}
                      type="text"
                      variant="outlined"
                      name="od_ifsc_code"
                      onChange={(e) => handleActivateChange('od_ifsc_code', e.target.value)}
                      onInput={handleIfscInput}
                      sx={{
                        input: {
                          background: '#f9f9f9'
                        }
                      }}
                    />
                    <Typography display={ActivateError.od_ifsc_code ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                      {ActivateErrMessage}
                    </Typography>
                  </Grid>
                  <Grid item xl={4} lg={4.5} md={8} sm={8} xs={8}>
                    <InputLabel htmlFor="outlined-adornment-lname-register" sx={{ mb: '10px' }}>
                      OD Bank Account Number
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-basic"
                      error={ActivateError.od_account_number}
                      fullWidth
                      value={ActivateData.od_account_number ? ActivateData.od_account_number : sessionStorage.getItem('od_account_number')}
                      inputProps={{
                        readOnly: BankAccVerified
                      }}
                      sx={{
                        input: {
                          background: '#f9f9f9'
                        }
                      }}
                      type="text"
                      variant="outlined"
                      name="od_account_number"
                      onChange={(e) => handleActivateChange('od_account_number', e.target.value)}
                      onInput={handleAccnoInput}
                    />
                    <Typography display={ActivateError.od_account_number ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                      {ActivateErrMessage}
                    </Typography>
                  </Grid>
                  <Grid item xl={2} lg={1.5} md={2} sm={2} xs={2} alignContent={'center'} mt={4}>
                    <Button
                      variant="contained"
                      // disabled
                      onClick={() => {
                        if (
                          !BankAccVerified &&
                          ActivateData.od_ifsc_code &&
                          ActivateData.od_ifsc_code.length === 11 &&
                          ActivateData.od_account_number
                        ) {
                          handleBankNoVerify(ActivateData.od_ifsc_code, ActivateData.od_account_number, StateData.name);
                        } else {
                          setVerifyButton(true);
                        }
                      }}
                      color={
                        BankAccVerified || sessionStorage.getItem('saving_ifsc_code') || sessionStorage.getItem('saving_acc_number')
                          ? 'success'
                          : 'secondary'
                      }
                      // sx={{ backgroundColor:  '#A556B2', '&:hover': { backgroundColor: '#A556B2' } }}
                    >
                      {BankAccVerified || sessionStorage.getItem('saving_ifsc_code') || sessionStorage.getItem('saving_acc_number')
                        ? 'Verified'
                        : 'Verify'}
                    </Button>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={8} xs={12}>
                    <InputLabel htmlFor="outlined-adornment-lname-register" sx={{ mb: '10px' }}>
                      OD Account Holder Name
                    </InputLabel>
                    <TextField
                      id="outlined-basic"
                      error={ActivateError.od_account_name}
                      fullWidth
                      value={
                        ActivateData.od_account_name
                          ? ActivateData.od_account_name
                          : NameBank
                          ? NameBank
                          : sessionStorage.getItem('od_account_name')
                      }
                      // label="OD Account Holder Name"
                      // disabled={DisableEmail ? DisableEmail : false}
                      type="text"
                      variant="outlined"
                      name="od_account_name"
                      onChange={(e) => handleActivateChange('od_account_name', e.target.value)}
                      inputProps={{
                        readOnly: true
                      }}
                      sx={{
                        input: {
                          background: '#f9f9f9'
                        }
                      }}
                    />
                    <Typography display={ActivateError.od_account_name ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
                      {ActivateErrMessage}
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionDetails>
              <AccordionActions sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid item xl={3} lg={3} md={3} xs={12} display="flex" justifyContent="center" mt={2}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="large"
                    // sx={{ width: '100%', marginRight: '15px' }}
                    sx={{
                      width: '100%',
                      marginRight: '15px',
                      borderColor: '#688B2A',
                      color: '#688B2A',
                      borderRadius: '6px',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    onClick={() => {
                      sessionStorage.removeItem('BankAccVerified'),
                        sessionStorage.removeItem('od_ifsc_code'),
                        sessionStorage.removeItem('od_account_number'),
                        sessionStorage.removeItem('od_account_name'),
                        Navigate(-1, {
                          state: { setValue: 1 }
                        });
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    sx={{
                      width: '100%',
                      backgroundColor: '#688B2A',
                      color: '#FFFFFF',
                      borderRadius: '6px',
                      '&:hover': {
                        backgroundColor: '#688B2A'
                      }
                    }}
                    onClick={handleBankSubmit}
                  >
                    submit
                  </Button>
                </Grid>
              </AccordionActions>
            </Accordion>
          )}
        </>
      )}
    </>
  );
};

export default Details;
